module.exports = __webpack_public_path__ + "static/media/staff_jacek_ciechanowski.43131a89.png";